import { InstallmentsStatus } from 'src/entities/Order';

export const Status = ({ status, dueDate }) => {
  switch (status) {
    case InstallmentsStatus.PAID:
      return <span className="d-inline-block confirmado-card">Pago</span>;
    case InstallmentsStatus.CANCELLED:
      return <span className="d-inline-block null-card">Cancelado</span>;
    case InstallmentsStatus.SENT:
      if (new Date(dueDate) >= new Date()) {
        return <span className="d-inline-block wait-card">Em aberto</span>;
      }
      return <span className="d-inline-block expired-card">Vencido</span>;

    default:
      return <span className="d-inline-block null-card">{status}</span>;
  }
};
